import type { Dispatch } from 'redux';

import { RESET_REDUX_STORE } from 'src/app/shared/constants/actionTypes';

export default () => (dispatch: Dispatch) => {
  dispatch({
    type: RESET_REDUX_STORE,
  });
};
